"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var form_properties_1 = require("../../model/form-properties");
var Observable_1 = require("rxjs/Observable");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var type_configuration_service_1 = require("../api/type-configuration.service");
var operators_1 = require("rxjs/operators");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_form_management_ui_1 = require("@synisys/idm-form-management-ui");
var core_1 = require("@angular/core");
var of_1 = require("rxjs/observable/of");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var http_1 = require("@angular/common/http");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var HttpFormResolutionService = /** @class */ (function () {
    function HttpFormResolutionService(typeConfigurationService, classifierService, formManagementService, currentLanguageProvider, applicationPropertiesService, deService, http) {
        this.typeConfigurationService = typeConfigurationService;
        this.classifierService = classifierService;
        this.formManagementService = formManagementService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.applicationPropertiesService = applicationPropertiesService;
        this.deService = deService;
        this.http = http;
        this._loadFormPath = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/de-service/forms"], ["", "/de-service/forms"])), 'serviceUri');
        this.idmFormServiceUrl$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty('form-service-url'));
    }
    HttpFormResolutionService.prototype.getForm = function (categoryId, entity, formType) {
        return this.getEntityFormProperties(categoryId, entity.getInstanceId(), entity).pipe(operators_1.map(function (formProperties) {
            if (formProperties) {
                return {
                    formId: formType === idm_dynamic_layout_interpreter_1.FormType.EDIT ? formProperties.editFormId : formProperties.viewFormId,
                    formName: formType === idm_dynamic_layout_interpreter_1.FormType.EDIT ? formProperties.editFormName : formProperties.viewFormName
                };
            }
            return null;
        }));
    };
    HttpFormResolutionService.prototype.getCategoryFormProperties = function (category) {
        var viewForms$ = this.formManagementService.loadFormsByCategoryAndType(category, idm_dynamic_layout_interpreter_1.FormType.VIEW);
        var editForms$ = this.formManagementService.loadFormsByCategoryAndType(category, idm_dynamic_layout_interpreter_1.FormType.EDIT);
        var currentLanguageId$ = this.currentLanguageProvider.getCurrentLanguage();
        return Observable_1.Observable.zip(viewForms$, editForms$, currentLanguageId$).pipe(operators_1.map(function (response) {
            var viewForm = response[0][0];
            var editForm = response[1][0];
            var currentLanguageId = response[2].getId();
            return new form_properties_1.FormProperties(viewForm.id, viewForm.name.getValue(currentLanguageId), editForm.id, editForm.name.getValue(currentLanguageId));
        }));
    };
    HttpFormResolutionService.prototype.getEntityFormProperties = function (category, entityId, data) {
        var _this = this;
        if (entityId) {
            var data$ = data ? Observable_1.Observable.of(data) : this.deService.loadEntityByInstanceId(category, entityId);
            return data$.pipe(operators_1.switchMap(function (entityData) {
                return _this.typeConfigurationService.getTypedCategoryProperties(category).pipe(operators_1.switchMap(function (value) {
                    if (value) {
                        var typeConfig = value.type;
                        var typeId = void 0;
                        var subTypeConfig = value.subType;
                        var subTypeId = void 0;
                        if (entityData['entity']) {
                            typeId = typeConfig ? entityData.entity[typeConfig.field] : undefined;
                            subTypeId = subTypeConfig ? entityData.entity[subTypeConfig.field] : undefined;
                        }
                        else if (entityData['getProperty']) {
                            var typeClassifier = typeConfig ? entityData.getProperty(typeConfig.field).value : undefined;
                            var subTypeClassifier = subTypeConfig ? entityData.getProperty(subTypeConfig.field).value : undefined;
                            typeId = typeClassifier ? typeClassifier.getId() : null;
                            subTypeId = subTypeClassifier ? subTypeClassifier.getId() : null;
                        }
                        else {
                            typeId = typeConfig ? entityData[typeConfig.field] : undefined;
                            subTypeId = subTypeConfig ? entityData[subTypeConfig.field] : undefined;
                        }
                        var typeClassifier$ = typeId ? _this.classifierService.loadClassifiersByIds(typeConfig.category, [typeId])
                            .map(function (res) { return res.getData()[0]; }) : of_1.of(null);
                        var subTypeClassifier$ = subTypeId ? _this.classifierService.loadClassifiersByIds(subTypeConfig.category, [subTypeId])
                            .map(function (res) { return res.getData()[0]; }) : of_1.of(null);
                        return Observable_1.Observable.zip(typeClassifier$, subTypeClassifier$, of_1.of(typeConfig), of_1.of(subTypeConfig));
                    }
                    else {
                        return of_1.of(null);
                    }
                }), operators_1.switchMap(function (value) {
                    if (value && value[0]) {
                        return _this.getFormProperties(category, value[0], value[1], value[2], value[3]);
                    }
                    else {
                        return _this.getCategoryFormProperties(category);
                    }
                }));
            }));
        }
        else {
            return this.getCategoryFormProperties(category);
        }
    };
    HttpFormResolutionService.prototype.getFormProperties = function (category, type, subType, typeConfig, subTypeConfig) {
        var _this = this;
        if (type) {
            var typeConfigurations$ = typeConfig ? of_1.of({ type: typeConfig, subType: subTypeConfig }) : this.typeConfigurationService.getTypedCategoryProperties(category);
            return typeConfigurations$.pipe(operators_1.concatMap(function (value) {
                var typeClassifier$ = of_1.of(null);
                var subTypeClassifier$ = of_1.of(null);
                if (typeof type === 'number') {
                    typeClassifier$ = _this.classifierService.loadClassifiersByIds(value.type.category, [type])
                        .map(function (classifierResponse) { return classifierResponse.getData()[0]; });
                    if (subType) {
                        subTypeClassifier$ = _this.classifierService.loadClassifiersByIds(value.subType.category, [subType])
                            .map(function (classifierResponse) { return classifierResponse.getData()[0]; });
                    }
                }
                else if (type instanceof idm_classifier_service_client_js_1.Classifier) {
                    typeClassifier$ = of_1.of(type);
                    if (subType) {
                        subTypeClassifier$ = of_1.of(subType);
                    }
                }
                return Observable_1.Observable.zip(typeClassifier$, subTypeClassifier$, of_1.of(value));
            }), operators_1.concatMap(function (value) {
                var typeClassifier = value[0];
                var subTypeClassifier = value[1];
                var configs = value[2];
                var typeFormProperties = new form_properties_1.FormProperties(typeClassifier.getProperty(configs.type.viewFormId).value, typeClassifier.getProperty(configs.type.viewFormName).value, typeClassifier.getProperty(configs.type.editFormId).value, typeClassifier.getProperty(configs.type.editFormName).value);
                var subTypeFormProperties = subTypeClassifier ? new form_properties_1.FormProperties(subTypeClassifier.getProperty(configs.subType.viewFormId).value, subTypeClassifier.getProperty(configs.subType.viewFormName).value, subTypeClassifier.getProperty(configs.subType.editFormId).value, subTypeClassifier.getProperty(configs.subType.editFormName).value) : null;
                if (typeFormProperties) {
                    if (subTypeFormProperties) {
                        return of_1.of(new form_properties_1.FormProperties(subTypeFormProperties.viewFormId ? subTypeFormProperties.viewFormId : typeFormProperties.viewFormId, subTypeFormProperties.viewFormName ? subTypeFormProperties.viewFormName : typeFormProperties.viewFormName, subTypeFormProperties.editFormId ? subTypeFormProperties.editFormId : typeFormProperties.editFormId, subTypeFormProperties.editFormName ? subTypeFormProperties.editFormName : typeFormProperties.editFormName));
                    }
                    else {
                        return of_1.of(new form_properties_1.FormProperties(typeFormProperties.viewFormId, typeFormProperties.viewFormName, typeFormProperties.editFormId, typeFormProperties.editFormName));
                    }
                }
                else {
                    return _this.getCategoryFormProperties(category);
                }
            }));
        }
        else {
            return this.getCategoryFormProperties(category);
        }
    };
    HttpFormResolutionService.prototype.getSubEntityFormProperties = function (category, subCategory) {
        var _this = this;
        return this.idmFormServiceUrl$.pipe(operators_1.switchMap(function (url) {
            var urlOfRequest = _this._loadFormPath.replaceTemplate({ serviceUri: url });
            var headers = new http_1.HttpHeaders().set('Content-Type', 'application/json');
            var paramsViewForm = new http_1.HttpParams()
                .set('categorySystemName', category)
                .set('subCategorySystemName', subCategory)
                .set('typeId', idm_dynamic_layout_interpreter_1.FormType.VIEW.toString());
            var paramsEditForm = new http_1.HttpParams()
                .set('categorySystemName', category)
                .set('subCategorySystemName', subCategory)
                .set('typeId', idm_dynamic_layout_interpreter_1.FormType.EDIT.toString());
            return Observable_1.Observable.zip(_this.http.get(urlOfRequest, { headers: headers, params: paramsViewForm }), _this.http.get(urlOfRequest, { headers: headers, params: paramsEditForm }));
        }), operators_1.map(function (response) {
            var viewForm = response[0][0];
            var editForm = response[1][0];
            return new form_properties_1.FormProperties(viewForm.id, viewForm.formSystemName, editForm.id, editForm.formSystemName);
        }));
    };
    HttpFormResolutionService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [type_configuration_service_1.TypeConfigurationService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_form_management_ui_1.FormManagementService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_de_service_client_js_1.DeService,
            http_1.HttpClient])
    ], HttpFormResolutionService);
    return HttpFormResolutionService;
}());
exports.HttpFormResolutionService = HttpFormResolutionService;
var templateObject_1;
//# sourceMappingURL=http-form-resolution.service.js.map